import {
  LayoutDashboard, ShoppingCart, Package, FileText,
  Wallet, Users, Shield, BarChart3,
  Store, Building2, MapPin, CreditCard, Home, Truck, HeartHandshake, Server, Settings, Plug, Heart, Mail,
} from 'lucide-react';

// « Mon Espace » mène à l'espace du rôle de l'utilisateur.
export const SPACE_BY_ROLE = {
  vendor: '/espace-vendeur',
  COOPER: '/espace-cooper',
  EXPERT: '/espace-expert',
  GERANT_LOLO_POINT: '/gerant',
  DETAILLANT: '/espace-detaillant',
  OPERATEUR_POS: '/pos',
  TITULAIRE_PASS: '/pass',
};

export const isAdminUser = (user) =>
  Boolean(user?.is_admin || ['admin', 'ADMIN', 'SUPER_ADMIN'].includes(user?.role) || user?.email?.includes('admin'));

export const getMySpace = (user) =>
  (isAdminUser(user) ? '/superadmin' : SPACE_BY_ROLE[user?.role] || '/espace-acheteur');

export const getNavItems = (userRole, isAdmin, pathname = '/') => {
  const mySpace = isAdmin ? '/superadmin' : SPACE_BY_ROLE[userRole] || '/espace-acheteur';
  // Top bar: keep it lean — 4 public + 2 member shortcuts.
  const isPass = userRole === 'TITULAIRE_PASS';
  const baseItems = [
    { href: '/', label: 'nav.home', icon: Home, public: true },
    { href: '/adhesion-vendeur', label: 'nav.pro_access', icon: Store, public: true },
    { href: isPass ? '/catalogue-lolodrive' : '/catalogue', label: 'nav.catalog_pro', icon: ShoppingCart, public: true },
    { href: '/territoires', label: 'nav.territories', icon: MapPin, public: true },
  ].filter((it) => !(isPass && it.href === '/tarifs'));

  // Member-only shortcuts déplacés en pied de page (demande utilisateur).
  const memberShortcuts = [];

  // Espaces dédiés par rôle (COOPER / EXPERT)
  const roleSpaces = [];
  if (userRole === 'COOPER' || isAdmin) roleSpaces.push({ href: '/espace-cooper', label: 'Espace COOPER', icon: Users });
  if (userRole === 'EXPERT' || isAdmin) roleSpaces.push({ href: '/espace-expert', label: 'Espace Expert', icon: BarChart3 });

  // Everything below is available via the user-avatar dropdown, not the top bar.
  return {
    topBar: baseItems.concat(userRole || isAdmin ? memberShortcuts : []),
    dropdown: {
      buyer: isPass ? [
        { href: mySpace, label: 'nav.my_space', icon: LayoutDashboard },
        { href: '/catalogue-lolodrive', label: 'nav.catalog', icon: ShoppingCart },
      ] : [
        { href: mySpace, label: 'nav.my_space', icon: LayoutDashboard },
        { href: '/commandes', label: 'nav.my_orders', icon: Package },
        { href: '/wallet', label: 'nav.wallet', icon: Wallet },
        { href: '/documents', label: 'nav.documents', icon: FileText },
        { href: '/listes-achats', label: 'nav.shopping_lists', icon: ShoppingCart },
        { href: '/alertes-favoris', label: 'nav.favorite_alerts', icon: Heart },
      ],
      vendor: (userRole === 'vendor' || isAdmin ? [
        { href: '/espace-vendeur', label: 'nav.vendor_space', icon: Store },
      ] : []).concat(roleSpaces),
      admin: isAdmin ? [
        { href: '/superadmin', label: 'nav.super_admin', icon: Shield },
        { href: '/admin/plans', label: 'nav.plans_credits', icon: CreditCard },
        { href: '/admin-v2', label: 'nav.admin_orgs', icon: Building2 },
        { href: '/admin/produits', label: 'nav.product_validation', icon: Package },
        { href: '/admin/stripe-reconciliation', label: 'nav.stripe_recon', icon: CreditCard },
        { href: '/admin/connecteurs', label: 'nav.connectors', icon: Plug },
        { href: '/admin/ged-bridge', label: 'nav.ged_bridge', icon: Server },
        { href: '/admin/finance-bridge', label: 'nav.finance_bridge', icon: CreditCard },
      ] : [],
    },
  };
};

